var map = {
	"./5362f33b4d169.SLDASM/5362f33b4d169.SLDASM.jpg": "b54b",
	"./9.1_M040_SmokeCheck_Dataset_WIN/I3-071211-1148-Sasm01.CATProduct.jpg": "f2c1",
	"./tuoluobeng/asm0002.asm.jpg": "d20b",
	"./总装配/冲床装配图.SLDASM.jpg": "6c7f",
	"./齿轮油泵.SLDASM/齿轮油泵.SLDASM.jpg": "8551"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c38";